export const DEFAULT_UP_LABEL: string = "File upload";
